// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-sizeattributelabel_default__1dlqf","label":"idt-sizeattributelabel_label__1rhq0","subText":"idt-sizeattributelabel_subtext__2gw0k"};